import { createReducer } from '@reduxjs/toolkit';
import { setClearFilterOptions, setFilterOptions, setIsNotifyMeLoaded, setProductCardData, setProductCardLabels, setProductQuantity, setSelectedCompatibilityProduct, setLinkForTestRide, setView360State, setProductSkuList, setCompatibilityCheckAllowed, setIsTestRideLinkLoaded, setPrevPageType, setPrevGroupingProductSku, setConfiguratorTestRideMap, } from './actions';
import { INITIAL_FILTER_OPTIONS_STATE, INITIAL_LABELS_STATE } from './constants';
export const initialState = {
    labels: INITIAL_LABELS_STATE,
    is360ViewOpen: false,
    filterOptions: INITIAL_FILTER_OPTIONS_STATE,
    isNotifyMeLoader: false,
    skuList: [],
    linkForTestRide: '',
    configuratorTestRideMap: null,
    prevPageType: '',
    prevGroupingProductSku: '',
    isTestRideLinkLoaded: false,
    selectedCompatibilityProduct: null,
    productQuantity: 1,
    isCompatibilityCheckAllowed: true,
};
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setProductCardData, (state, action) => ({
        ...state,
        ...action.payload,
    }))
        .addCase(setIsNotifyMeLoaded, (state, action) => ({
        ...state,
        isNotifyMeLoader: action?.payload,
    }))
        .addCase(setLinkForTestRide, (state, action) => ({
        ...state,
        linkForTestRide: action?.payload,
    }))
        .addCase(setPrevPageType, (state, action) => ({
        ...state,
        prevPageType: action?.payload,
    }))
        .addCase(setPrevGroupingProductSku, (state, action) => ({
        ...state,
        prevGroupingProductSku: action?.payload,
    }))
        .addCase(setIsTestRideLinkLoaded, (state, action) => ({
        ...state,
        isTestRideLinkLoaded: action.payload,
    }))
        .addCase(setProductSkuList, (state, action) => ({
        ...state,
        skuList: action?.payload,
    }))
        .addCase(setProductCardLabels, (state, { payload }) => ({
        ...state,
        labels: {
            ...state.labels,
            ...payload,
        },
    }))
        .addCase(setView360State, (state, action) => ({
        ...state,
        is360ViewOpen: action.payload,
    }))
        // Reducers for filter
        .addCase(setFilterOptions, (state, action) => ({
        ...state,
        filterOptions: {
            ...state.filterOptions,
            ...action.payload,
        },
    }))
        .addCase(setClearFilterOptions, (state) => ({
        ...state,
        filterOptions: {
            ...INITIAL_FILTER_OPTIONS_STATE,
        },
    }))
        .addCase(setSelectedCompatibilityProduct, (state, action) => ({
        ...state,
        selectedCompatibilityProduct: action.payload,
    }))
        .addCase(setCompatibilityCheckAllowed, (state, action) => ({
        ...state,
        isCompatibilityCheckAllowed: action.payload,
    }))
        .addCase(setProductQuantity, (state, action) => ({
        ...state,
        productQuantity: action.payload,
    }))
        .addCase(setConfiguratorTestRideMap, (state, action) => ({
        ...state,
        configuratorTestRideMap: action?.payload,
    }));
});
